import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=7b123e18"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/overseas_platform_beta/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b123e18')) {
      api.createRecord('7b123e18', component.options)
    } else {
      api.reload('7b123e18', component.options)
    }
    module.hot.accept("./SideBarItem.vue?vue&type=template&id=7b123e18", function () {
      api.rerender('7b123e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/SideBarItem.vue"
export default component.exports